import { EventParentTypes } from '../../config'

/** Labels for the shared audit-log target-type taxonomy. */
export function auditTargetTypeLabel(targetTypeId: number): string | null {
    switch (targetTypeId) {
        case EventParentTypes.CAMPAIGN:
            return 'Campaign'
        case EventParentTypes.AD_GROUP:
            return 'Ad Group'
        case EventParentTypes.PRODUCT_AD:
            return 'Product Ad'
        case EventParentTypes.Ads:
            return 'Ad'
        case EventParentTypes.KEYWORD:
            return 'Keyword'
        case EventParentTypes.TARGETS:
            return 'Target'
        case EventParentTypes.CampaignNegativeKeywords:
            return 'Campaign Negative Keyword'
        case EventParentTypes.NegativeKeywords:
            return 'Negative Keyword'
        case EventParentTypes.NegativeTargets:
            return 'Negative Target'
        case EventParentTypes.Portfolios:
            return 'Portfolio'
        case EventParentTypes.Promotion:
            return 'Smart Campaign'
        case EventParentTypes.Recipe:
            return 'Recipe'
        default:
            return null
    }
}
